Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCogData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='4'/%3e%3cpath d='M21 12a3 3 0 001.67 2.68 10.94 10.94 0 01-1.22 3 3 3 0 00-3.81 3.81 10.94 10.94 0 01-3 1.22 3 3 0 00-5.36 0 10.94 10.94 0 01-3-1.22 3 3 0 00-3.81-3.81 10.94 10.94 0 01-1.22-3 3 3 0 000-5.36 10.94 10.94 0 011.22-3 3 3 0 003.89-3.77 10.94 10.94 0 013-1.22 3 3 0 005.36 0 10.94 10.94 0 013 1.22 3 3 0 003.81 3.81 10.94 10.94 0 011.22 3A3 3 0 0021 12z' stroke-linecap='round'/%3e%3c/g%3e%3c/svg%3e",
  iconCogWidth: 24,
  iconCogHeight: 24
};